<template>
  <div class="learingList" id="foot-parent">
      <commonHeader ></commonHeader>
    <div class="foot-container" v-if="isFrameLoad" style="margin-top:-33px;">
      <!-- <iframe  id="foot-earth" :src="iframeAddr"></iframe> -->
    <cesiumContainerWar v-bind:user-name="username"></cesiumContainerWar>
    </div>

    <!-- <mt-navbar v-model="selected" style="margin-bottom:3px;">
        <mt-tab-item id="1" style="color:black;">大国外交</mt-tab-item>
        <mt-tab-item id="2" style="color:black;">生态文明</mt-tab-item>
      </mt-navbar> -->

      <!-- <mt-tab-container v-model="selected" style="height:100%">
        <mt-tab-container-item id="1" style="height:100%">
           <div class="foot-container">
              <iframe id="foot-earth" :src="iframeAddr"></iframe>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item id="2" style="overflow:scroll;">
          <mt-swipe :auto="4000" style="" v-bind:style="{ height: heightLunbo + 'px' }">
            <mt-swipe-item v-for="lunboNew in lunboNews">
              <div class="banner" :style="{backgroundImage:'url('+lunboNew.imgurl+')'}" @click="showLunboNew(lunboNew.link)"></div>
            </mt-swipe-item>
          </mt-swipe>
          <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
            <div v-for="xinwen in xinwens" @click="goXinwen(xinwen.link)" style="border-bottom:1px solid #DADADD;display:flex;">
                <div style="flex:1;padding-top:5px;padding-left:7px;">
                  <img :src="xinwen.imgurl" style="height:42px;width:42px;">
                </div>
                
                <div style="flex:4;padding-top:5px;">
                  <span style="text-align:left;">{{limitLen(xinwen.title,14)}}</span>
                  <p style="font-size:14px;color:gray;text-align:left;">{{limitLen(xinwen.content,15)}}</p>
                </div>
            </div>
          </div>
          <div style="height:45px;"></div>
        </mt-tab-container-item>
      </mt-tab-container> -->

    <!-- <div class="foot-container">
        <iframe id="foot-earth" :src="iframeAddr"></iframe>
    </div> -->
  </div>
</template>
<script>
import openUrl from "./../utils/openUrl";
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import commonHeader from "./../components/common-header.vue";
import cesiumContainerWar from "./cesiumContainerWar.vue";

import { Toast, MessageBox } from "mint-ui";

import ilabX from "./../utils/ilabX";

export default {
  name: "learingList",
  data() {
    return {
      isFrameLoad:true,
      // isFrameLoad:false,
      loading: false,
      heightLunbo: 200,
      heightSize: 160,
      lunboNews: [],
      xinwens: [],
      username:"",

      // iframeAddr:
      //   "http://wykcug.com:8082/apptest4/index.html#/war?username=" +this.$store.state.mineStore.userId, //"http://localhost:8081/#/war?username=" "http://localhost:8083/#/war?username="+this.$store.state.mineStore.userId,//"http://wykcug.com:8082/apptest/index.html#/war", //"http://wykcug.com:8082/3dglobal/yidaApp3DEarth1.html", //Addr.getAliYunAddr() + "yidaApp3DEarth1.html",//"http://wykcug.com:8082/3dglobal/yidaApp3DEarth1.html",
        
      imgBaseUrl: cfg.imgBaseUrl,
      searchValue: "", // 搜索关键词
      selected: this.$store.state.mineStore.tab, // 分类选项
      listItemData: [], // 分类列表
      listInfoData: [] // 当前分类信息
    };
  },
  watch: {
    selected: function(newVal, oldVal) {
      console.log("selectd change");
      console.log(oldVal);
      console.log(newVal);
      if (newVal == 1) {
        document.getElementById("foot-parent").style.height = "100%!important";
      }
      if (newVal == 2) {
        document.getElementById("foot-parent").style.height =
          "2000px!important";
      }
    }
  },
  methods: {
    loadMore() {
      console.log("loadMore");
      this.loading = true;
      setTimeout(() => {
        // let last = this.list[this.list.length - 1];
        // for (let i = 1; i <= 10; i++) {
        //   this.list.push(last + i);
        // }
        this.loading = false;
      }, 2500);
    },
    goXinwen(link) {
      //store.dispatch("updateTab", "xijinping-item");
      this.$store.commit("updateTab", "2");
      //window.location.href = link;
      openUrl.open(link);
    },
    showLunboNew(link) {
      this.$store.commit("updateTab", "2");
      //window.location.href = link;
      openUrl.open(link);
    },
    //限制长度
    limitLen(content, maxLen) {
      if (window.innerWidth > 700) {
        return content.length > 38
          ? content.slice(0, 38) + "..."
          : content + "...";
      }
      return content.length > maxLen
        ? content.slice(0, maxLen) + "..."
        : content + "...";
    },
    initXiLunboData() {
      axios
        .get(Addr.getGoAPIPrefix() + "xi/listXiLunbo?pageNum=1&pageRow=1000")
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            this.lunboNews = res.data.returnData.list;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    initXiNewsData() {
      axios
        .get(Addr.getGoAPIPrefix() + "xi/listXiNews?pageNum=1&pageRow=1000")
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            this.xinwens = res.data.returnData.list;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    setSize() {
      if (window.innerWidth > cfg.widthLimit) {
        this.heightSize = 360;
        this.heightLunbo = 360;
      }
      if (window.innerWidth > 900) {
        this.heightLunbo = 450;
      }

      if (document.getElementById("foot-parent")) {
        //设置地图高度
        document.getElementById("foot-parent").style.height =
          window.innerHeight - 64 + "px";
      }
    }
  },
  created: function() {
    this.$store.commit("updateTab", "1");
  },
  mounted: function() {
    console.log("token is");
    console.log(this.$route.query.token);

    // if (this.$route.query.token) {

    //   axios
    //     .get(
    //       ilabX.getAPIPrefix() +
    //         "ilabx/parseToken?token=" +
    //         encodeURIComponent(this.$route.query.token)
    //       // +"&testToken="+encodeURIComponent("AAABa9WPDuwCAAAAAAABhqE%3D.abAHDyqMvkjDciR%2FAx9IWzJjc1dhdMAW5LnRBDt2bSKyhmWhyabvu5%2BxlxRQna6k.MN8%2B%2Fm4q83cNbXmZoBb8sGi7GHkrrg%2BVwqyokk1B3Sg%3D")
    //     )
    //     .then(res => {
    //       console.log("this query token is:");
    //       console.log(this.$route.query.token);


    //       console.log("res is:");
    //       console.log(res);
    //       if (res.data && res.data.dis && res.data.un) {
    //         //this.$store.dispatch("updateUserId", res.data.returnData);
    //         this.$store.commit("updateUserId", res.data.un);
    //         console.log(this.$store.state.mineStore.userId);

    //         // this.iframeAddr="http://wykcug.com:8082/apptest4/index.html#/war?username=" +this.$store.state.mineStore.userId;
    //         this.username=this.$store.state.mineStore.userId


    //         //this.$store.dispatch("updateUserName", this.login_username);
    //         this.$store.commit("updateUserName", res.data.dis);
    //         //this.$store.dispatch("updateIsLogin", true);
    //         this.$store.commit("updateIsLogin", true);

    //         //反馈在线人数
    //         axios
    //           .get(
    //             ilabX.getAPIPrefix() +
    //               "ilabx/addOnlineNumber?userId=" +
    //               res.data.un
    //           )
    //           .then(res => {
    //             console.log("res is:");
    //             console.log(res);
    //           })
    //           .catch(err => {
    //             console.log(err);
    //           });

    //         //实验状态返回
    //         axios
    //           .get(
    //             ilabX.getAPIPrefix() +
    //               "ilabx/returnState?username=" +
    //               res.data.un
    //           )
    //           .then(res => {
    //             console.log("res is:");
    //             console.log(res);
    //             if (res.data.code == 0 || res.data.code == 7) {
    //               // Toast({
    //               //   message: "实验状态反馈成功",
    //               //   position: "bottom",
    //               //   duration: 800
    //               // });
    //             } else {
    //               Toast({
    //                 message: "实验状态反馈存在问题",
    //                 position: "bottom",
    //                 duration: 800
    //               });
    //             }
    //           })
    //           .catch(err => {
    //             console.log(err);
    //           });
    //       }

    //       //不等用户名获取的话  会有问题
    //       this.isFrameLoad=true;
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // } else {

    //   //不等用户名获取的话  会有问题
    //   this.isFrameLoad=true;

    //   if (this.$store.state.mineStore.userId != "") {
    //     //如果已经加载过生成过游客id
    //     axios
    //       .get(
    //         ilabX.getAPIPrefix() +
    //           "ilabx/addOnlineNumber?userId=" +
    //           this.$store.state.mineStore.userId
    //       )
    //       .then(res => {
    //         console.log("res is:");
    //         console.log(res);
    //       })
    //       .catch(err => {
    //         console.log(err);
    //       });
    //   } else {
    //     //在线人数生成游客id
    //     this.$store.commit(
    //       "updateUserId",
    //       "xijingpingxijingping"+ilabX.generate16Character()
    //     );
    //     axios
    //       .get(
    //         ilabX.getAPIPrefix() +
    //           "ilabx/addOnlineNumber?userId=" +
    //           this.$store.state.mineStore.userId
    //       )
    //       .then(res => {
    //         console.log("res is:");
    //         console.log(res);
    //       })
    //       .catch(err => {
    //         console.log(err);
    //       });
    //   }
    // }

    // this.initXiNewsData();
    // this.initXiLunboData();

    window.addEventListener("resize", () => {
      this.setSize();
    });
    this.setSize();
  },
  components: {
    commonHeader,
    cesiumContainerWar
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/baseScss";

.mint-tab-container-wrap {
  height: 100%;
}

.mint-navbar .mint-tab-item.is-selected {
  color: #e70202 !important;
  border-bottom: 2px solid #e70202 !important;
}

.foot-container {
  //position: absolute;
  /* top: 0px; */
  /* z-index:99; */
  // top: 40px;
  height: 100%;
  width: 100%;
  //z-index: 999999;
}
#foot-earth {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0px;
  //z-index: 999999;
}

.learingList {
  height: 100%;
  // height:2000px;
  // .listBox {
  //   display: flex;
  //   .mint-navbar {
  //     display: block;
  //     flex: 2;
  //     .mint-tab-item {
  //       border-left: 3px solid $cl1;
  //       border-bottom: 3px solid $cl1;
  //     }
  //     .is-selected {
  //       background: $cl5;
  //       border-bottom: 3px solid $cl1;
  //       border-left: 3px solid $cl0;
  //     }
  //   }
  //   .mint-tab-container {
  //     text-align: center;
  //     line-height: 30px;
  //     flex: 6;
  //     a {
  //       color: $cl6;
  //       display: block;
  //       background: $cl1;
  //       margin: 10px 15px 0px 0px;
  //       font-size: 15px;
  //       line-height: 40px;
  //     }
  //     .banner {
  //       padding: 15px 15px 0px 15px;
  //     }
  //     .labs {
  //       display: flex;
  //       flex-wrap: wrap;
  //       padding-left: 15px;
  //       a {
  //         flex-grow: 2;
  //         width: 40%;
  //       }
  //     }
  //     .tit {
  //       text-align: left;
  //       padding: 10px 0px 0px 15px;
  //       color: $cl3;
  //     }
  //     .recLabs {
  //       padding-left: 15px;
  //     }
  //   }
  // }
}
.common-header /deep/ .mint-header{
    position:absolute !important;
    width: 35px !important;
    height: 32px !important ;
    // top:33px !important;
}
</style>



// WEBPACK FOOTER //
// src/module-list/index.vue